<template>
    <router-view/>
  </template>
  <script>
  export default {
      beforeRouteUpdate(to, from, next) {
          if(to.name == 'b2b-politica-comercial'){
              next({ name: 'b2b-politica-comercial-list' })
          }else{
              next()
          }
      },
      created() {
          if(this.$route.name == 'b2b-politica-comercial'){
              this.$router.push({ name: 'b2b-politica-comercial-list' })
          }
      }
  }
  </script>